import React, { useEffect, useState } from "react";

import "./AdminScreen.css";
import {
  List,
  ListItem,
} from "@mui/material";
import { Auth } from "aws-amplify";
import AWS from "aws-sdk";
import { addUserApi, removeUserApi, getAllUserDataApi } from "../../../Api";

import {
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
  Button,
  Input,
  SelectItem,
  Select,
} from "@nextui-org/react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "@nextui-org/react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function AdminScreen() {
  const [loginHistoryPopupOpen, setLoginHistoryPopupOpen] = useState(false);
  const [displayUserId, setDisplayUserId] = useState(0);

  const [addUserPopupOpen, setAddUserPopupOpen] = useState(false);
  const [deleteUserPopupOpen, setDeleteUserPopupOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(0);

  const [allUserData, setAllUserData] = useState([]);

  const toggleLoginHistory = (userId) => {
    setLoginHistoryPopupOpen(true);
    setDisplayUserId(userId);
  };

  const toggleAddUserPopupOpen = (toggle = !addUserPopupOpen) => {
    setAddUserPopupOpen(toggle);
  };

  const handleAddUserSubmit = async (email, password, firstName, lastName, role, callback) => {
    let response;

    try {
      response = await Auth.signUp({
        username: email,
        password: password,
        attributes: {
          email, // optional
        },
        autoSignIn: {
          // optional - enables auto sign in after user is confirmed
          enabled: false,
        },
      });
    } catch (error) {
      console.log("error AUTH signing up:", error);
      callback(error);
      return;
    }

    try {
      const dbCallback = () => {
        callback("");
        setAllUserData([
          ...allUserData,
          {
            id: response.userSub,
            email: email,
            firstName: firstName,
            lastName: lastName,
            loginHistory: []
          }
        ])
      };
      addUserApi(
        {
          id: response.userSub,
          email: email,
          firstName: firstName,
          lastName: lastName,
          role: role,
        },
        dbCallback
      );
    } catch (error) {
      console.log("error DB signing up:", error);
      callback(error);
    }
  };

  const handleAllUserDataCallback = (rtndata) => {
    if (rtndata["status"] === "ERROR") {
      console.log("ERROR");
    } else {
      const cleanData = rtndata.data.filter(
        (user) => !!user.lastName && !!user.firstName && !!user.email
      );
      let uniqueUsers = [];
      const seen = new Set();
      for (const user of cleanData) {
        if (!seen.has(user.email.S)) {
          // Assuming 'username' is the unique attribute
          seen.add(user.email.S);
          uniqueUsers.push(user);
        }
      }
      const filteredData = uniqueUsers
        .map((rawUser) => {
          const cleanedUserData = {};

          cleanedUserData.id = rawUser.id.S;
          cleanedUserData.lastName = rawUser.lastName.S;
          cleanedUserData.firstName = rawUser.firstName.S;
          cleanedUserData.email = rawUser.email.S;
          cleanedUserData.loginHistory = [];

          if (rawUser.loginHistory) {
            cleanedUserData.loginHistory = rawUser.loginHistory.L.map((login) => {
              return parseInt(login.N);
            });
          }

          return cleanedUserData;
        })
        .filter((record) => !record.firstName.includes("Tristan"));

      setAllUserData(filteredData);
    }
  };

  useEffect(() => {
    getAllUserDataApi(handleAllUserDataCallback);
  }, []);

  console.log(allUserData);

  const AddUserPopup = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [role, setRole] = useState("");

    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");

    const saveCallback = (error) => {
      if (error !== "") {
        setSaving(false);
        setError(error);
        toast.error("Error creating new user");
      } else {
        setSaving(false);
        setAddUserPopupOpen(false);
        toast.success("Created new user successfully");
      }
    };

    const handleSubmit = () => {
      setError("");
      setSaving(true);
      handleAddUserSubmit(email, password, firstName, lastName, role, saveCallback);
    };

    console.log(error);

    const onOpenAddPopupChange = (v) => {
      if (!v) {
        setAddUserPopupOpen(false);
      }
    };

    return (
      <Modal isOpen={addUserPopupOpen} onOpenChange={onOpenAddPopupChange}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">Add User</ModalHeader>
              <ModalBody>
                <div className="flex flex-col gap-3">
                  <Input
                    type="email"
                    label="Email"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                  />
                  <Input
                    label="Password"
                    value={password}
                    type="password"
                    onChange={(event) => setPassword(event.target.value)}
                  />
                  <Input
                    label="First Name"
                    value={firstName}
                    onChange={(event) => setFirstName(event.target.value)}
                  />
                  <Input
                    label="Last Name"
                    value={lastName}
                    onChange={(event) => setLastName(event.target.value)}
                  />
                  <Select
                    label="Role"
                    value={role}
                    onChange={(event) => setRole(event.target.value)}
                  >
                    <SelectItem key={"employee"} value={"employee"}>
                      Team Member
                    </SelectItem>
                    <SelectItem key={"manager"} value={"manager"}>
                      Team Leader
                    </SelectItem>
                  </Select>
                </div>
                {/* {error !== "" && (
                  <div className="px-2">
                    <div className="text-red-500">ERROR: {JSON.stringify(error)}</div>
                  </div>
                )} */}
              </ModalBody>
              <ModalFooter>
                <Button color="primary" isLoading={saving} onPress={handleSubmit}>
                  Submit
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    );
  };

  const DeleteUserPopup = () => {
    const [saving, setSaving] = useState(false);
    const onOpenDeletePopupChange = (v) => {
      if (!v) {
        setDeleteUserPopupOpen(false);
      }
    };

    const handleSubmit = async () => {
      setSaving(true);
      // AWS.config.update({
      //   accessKeyId: 'AKIA5ALPIN574Z23XI5G',
      //   secretAccessKey: '/vChdDcyNi5A/wzZd8TioJzprw80tjA0woH3psFMh',
      //   region: 'us-east-2'
      // });
  
      // // Create the service client with new V3 SDK
      // const cognitoIdentityServiceProvider = new AWS.CognitoIdentityServiceProvider();
  
      // var params = {
      //   UserPoolId: 'us-east-2_fzDGz6Y1H', /* required */
      //   Username: selectedUserId /* required */
      // };
  
      // // cognitoIdentityServiceProvider.adminDeleteUser(params, function(err, data) {
      // //   if (err) console.log(err, err.stack); // an error occurred
      // //   else     console.log(data);           // successful response
      // // });
      // await cognitoIdentityServiceProvider.adminDeleteUser(params).promise();
  
      try {
        const dbCallback = () => {
          toast.success("Deleted new user successfully");
          setSaving(false);
          setDeleteUserPopupOpen(false);
          setAllUserData(allUserData.filter(user => user.id !== selectedUserId));
        }
        removeUserApi(selectedUserId, dbCallback);
      } catch (err) {
        console.log(err);
        setSaving(false);
        setDeleteUserPopupOpen(false);
        toast.error("Error deleting user");
      }
    };

    const handleCancel = () => {
      setDeleteUserPopupOpen(false);
    }

    return (
      <Modal isOpen={deleteUserPopupOpen} onOpenChange={onOpenDeletePopupChange}>
        <ModalContent>
          {() => (
            <>
              <ModalHeader className="flex flex-col gap-1">Confirmation</ModalHeader>
              <ModalBody className="text-center">
                Are you sure you want to delete this user?
              </ModalBody>
              <ModalFooter>
                <Button color="danger" isLoading={saving} onPress={handleSubmit}>
                  Confirm
                </Button>
                <Button color="default" onPress={handleCancel}>
                  Cancel
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    )
  }

  const onOpenHistoryPopupChange = (v) => {
    if (!v) {
      setLoginHistoryPopupOpen(false);
    }
  };

  const handleResetPassword = async (username) => {
    try {
      const data = await Auth.forgotPassword(username);
      console.log(data);
    } catch (err) {
      console.log(err);
    }
  };

  const handleDeleteUser = async (userId) => {
    setSelectedUserId(userId);
    setDeleteUserPopupOpen(true);
  };

  return (
    <div className="flex justify-center min-h-screen">
      <div className="max-w-[1280px]">
        {/* <div className="admin-screen-header">Admin Panel</div> */}
        <div className="text-3xl font-bold text-[#002e62] text-center">Admin Panel</div>
        <div className="flex justify-end mb-2">
          {/* <PrimaryButton text={"Add User"} onClick={() => toggleAddUserPopupOpen(true)} /> */}
          <Button color="primary" className="bg-[#002e62]" onPress={() => toggleAddUserPopupOpen(true)}>
            Add User{" "}
          </Button>
        </div>
        <Table aria-label="Example static collection table" className="mb-4">
          <TableHeader>
            <TableColumn className="border border-gray-200">NO</TableColumn>
            <TableColumn className="border border-gray-200">NAME</TableColumn>
            <TableColumn className="border border-gray-200">EMAIL</TableColumn>
            <TableColumn className="border border-gray-200">LAST LOGIN</TableColumn>
            <TableColumn className="border border-gray-200">ACTIONS</TableColumn>
          </TableHeader>
          <TableBody>
            {/* <TableRow key="1">
              <TableCell>Tony Reichert</TableCell>
              <TableCell>CEO</TableCell>
              <TableCell>Active</TableCell>
            </TableRow> */}

            {allUserData.map((user, index) => {
              const date =
                user.loginHistory.length === 0
                  ? "NONE"
                  : new Date(user.loginHistory[0]).toLocaleDateString();
              const time =
                user.loginHistory.length === 0
                  ? "NONE"
                  : new Date(user.loginHistory[0]).toLocaleTimeString();

              const displayTime = date === "NONE" ? "NONE" : date + " " + time;

              return (
                <TableRow
                  className="hover:cursor-pointer"
                  key={index}
                  onClick={() => toggleLoginHistory(user.id)}
                >
                  <TableCell className="border border-gray-200">{index + 1}</TableCell>
                  <TableCell className="border border-gray-200">
                    {user.firstName + " " + user.lastName}
                  </TableCell>
                  <TableCell className="border border-gray-200">{user.email}</TableCell>
                  <TableCell className="border border-gray-200">{displayTime}</TableCell>
                  <TableCell className="border border-gray-200">
                    {/* <Button
                      className="mr-2"
                      color="primary"
                      onPress={() => handleResetPassword(user.id)}
                    >
                      Reset password
                    </Button> */}
                    <Button color="primary" className="bg-[#002e62]" onPress={() => handleDeleteUser(user.id)}>
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
      {loginHistoryPopupOpen && (
        <Modal size="sm" isOpen={loginHistoryPopupOpen} onOpenChange={onOpenHistoryPopupChange}>
          <ModalContent>
            {/* <Modal open={loginHistoryPopupOpen} onClose={() => setLoginHistoryPopupOpen(false)}> */}
            <ModalHeader className="flex flex-col gap-1">View History</ModalHeader>
            <ModalBody>
              <List>
                {(() => {
                  const user = allUserData.find((user) => user.id === displayUserId);

                  if (user.loginHistory.length === 0) {
                    return (
                      <div className="h-[100px] flex flex-col justify-center items-center">
                        <h4>There are no history to display</h4>
                      </div>
                    );
                  }

                  return user.loginHistory
                    .slice(
                      user.loginHistory.length - Math.min(10, user.loginHistory.length),
                      user.loginHistory.length
                    )
                    .map((login) => {
                      const date = new Date(login).toLocaleDateString();
                      const time = new Date(login).toLocaleTimeString();

                      const displayTime = date + " " + time;

                      return <ListItem>{displayTime}</ListItem>;
                    });
                })()}
              </List>
            </ModalBody>
          </ModalContent>
        </Modal>
      )}

      {addUserPopupOpen && <AddUserPopup />}
      {deleteUserPopupOpen && <DeleteUserPopup />}
      <ToastContainer />
    </div>
  );
}

export default AdminScreen;
